export default __webpack_public_path__ + "static/media/pers_sp.70000a59.jpg";